// Advertiser PartnerLevels allowed to see the Impressions and Transactions
// columns on the V2 Transactions tab entity tables (Publishers, Creatives).
// Every other level has those columns hidden.
export const METRIC_VISIBLE_ADVERTISER_LEVELS = ['ENTERPRISE', 'CORE', 'CHANNEL_PARTNER_DIRECT'];

export const canShowTransactionMetrics = (advertiserLevel) =>
  METRIC_VISIBLE_ADVERTISER_LEVELS.includes(advertiserLevel);
